export default {
  es: {
    UPDATED_AT: 'Actualizado el',
    OFFER_END_IN: '¡La oferta termina en',
    I_WANT_IT: 'Lo deseo',
    REMOVE: 'Remover',
    SHARE: 'Compartir',
    SHARE_FREE_COURSE: 'Compártelo con tus amigos',
    ADD: 'Agregar',
    GIFT: 'Regalar',
    REQUIREMENTS_TITLE: '¿Qué necesito?',
    ABOUT_TITLE: '¿De qué trata este curso?',
    SHOW_CONTENT: 'Mostrar contenido',
    HIDE_CONTENT: 'Ocultar contenido',
    LESSONS_SECTION_TITLE: '¿Qué voy a aprender?',
    SHOW_ALL_LESSONS: 'Mostrar todo el temario',
    HIDE_ALL_LESSONS: 'Ocultar todo el temario',
    FEATURED_REVIEW_TITLE: 'Reseña destacada',
    REVIEWS_TITLE: 'Valoraciones',
    TOTAL_SCORE: 'Media total',
    LOAD_MORE_REVIEWS: 'Mostrar más comentarios',
    WATCH_TRAILER: 'Mira el trailer',
    BUY_NOW: 'Comprar ahora',
    ENROLL_NOW: 'Inscríbete ahora',
    YEARLY: 'Al año',
    BECOME_PREMIUM: 'Vuélvete Premium',
    PREMIUM_COPY: 'Forma parte de nuestra comunidad Premium',
    BUY_FRECUENTLY: 'Comprados frecuentemente',
    BEST_SELLER: 'Más vendido',
    NEW: 'Nuevo',
    STUDENTS: 'Estudiantes',
    FAQ_TITLE: 'Preguntas frecuentes',
    FAQ_QUESTION1_TITLE: '¿Tengo acceso ilimitado a las clases?',
    FAQ_QUESTION1_TEXT:
      '¡Si! Luego de que te inscribas al curso, vas a poder tener acceso ilimitado a las clases. El curso se queda en tu cuenta de Crehana para siempre.',
    FAQ_QUESTION1_TEXT_PAY:
      '¡Sí! Luego de que realices la compra vas a poder acceder a las clases cuando y donde quieras. El curso se queda en tu cuenta de Crehana para siempre. :)',
    FAQ_QUESTION2_TITLE: '¿Cuándo inicia el curso?',
    FAQ_QUESTION2_TEXT:
      'Todo el contenido es 100% en línea, con clases pregrabadas a las que tendrás acceso de manera ilimitada. ¡Puedes iniciarlo y desarrollarlo a tu propio ritmo!',
    FAQ_QUESTION2_TEXT_PAY:
      'Todo el contenido es 100% en línea, con clases pregrabadas a las que tendrás acceso luego de la compra del curso. ¡Puedes iniciarlo y desarrollarlo a tu propio ritmo!',
    FAQ_QUESTION3_TITLE: '¿Los cursos gratis tienen certificación?',
    FAQ_QUESTION3_TITLE_PAY: '¿Cómo obtengo el certificado del curso?',
    FAQ_QUESTION3_TEXT:
      'Para poder obtener una certificación, debes de inscribirte a un curso de paga. Puedes revisar nuestro catálogo',
    FAQ_QUESTION3_TEXT_PAY:
      'Luego de que termines el curso, debes de desarrollar el proyecto y publicarlo con la comunidad. El profesor del curso y equipo de Crehana lo revisará y si todo va bien, se te emite  la certificación para que lo descargues  desde tu cuenta.',
    SEO_TITLE: 'Curso online de',
    GO_TO_COURSE: 'Ir al curso',
    VALID_ONLY: '*Válido por 24hrs solo para nuevos usuarios',
    FREE_TRIAL: 'Pruébalo sin costo',
  },
};
